import { compose } from 'redux';
import type { GeofenceFormState } from './reducer';

import type { AppState } from '../AppState';

export const selectGeofenceFormDomain = (state: AppState): GeofenceFormState => state.geofenceForm;

export const selectGeofence = compose((state) => state.geofenceWebData, selectGeofenceFormDomain);
